import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommPlanDetail } from 'src/app/models/commission/comm-plan-detail.model';
import { CommPlan } from 'src/app/models/commission/comm-plan.model';
import { CommissionService } from 'src/app/service/commission.service';
import * as XLSX from 'xlsx';
import { FileSaver, saveAs } from 'file-saver';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { TableColumn } from 'src/app/home/table/TableColumn';
import { Buttons } from 'src/app/home/table/Buttons';
import { ExportExcelService } from 'src/app/service/export-excel.service';
import { NotificationService } from 'src/app/service/notification.service';
import { NotificationType } from 'src/app/enum/notification-type.enum';
import { CommissionPlanService } from 'src/app/service/commplan.service';

@Component({
  selector: 'app-view-plans',
  templateUrl: './view-plans.component.html',
  styleUrls: ['./view-plans.component.css']
})

export class ViewPlansComponent implements OnInit {

  commModel = new CommPlan();
  kpiDetails: CommPlanDetail[] = [];
  jsonData: any[];
  fileName: string = '';
  columnsData: any;
  ordersTableColumns: TableColumn[];
  buttons: Buttons[];
  dataForExcel = [];
  columnsExcelData: any;
  ordersTableExcelHeaderColumns: TableColumn[];
  exportExcelkpiDetails: CommPlanDetail[] = [];

  constructor(private commissionService: CommissionService,
    private router: Router, private httpService: HttpClient,
    private exportExcelService: ExportExcelService,private notificationService: NotificationService) { }

  fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
  fileExtension = '.xlsx';

  ngOnInit(): void {
    this.commModel = this.commissionService.commModel
    console.log(this.commModel);
    this.fileName = this.commModel.commPlan;
    this.initializeColumns();
    //this.kpiDetails = this.commissionService.kpiDetails;
    this.initializeExcelHeaders();
    this.getKPIDetails();
  }

  getKPIDetails() {
    this.kpiDetails = [];
    this.commissionService.getKpiDetailsForPlan(this.commModel.commPlanId, this.commModel.effective_date)
      .subscribe((data: CommPlanDetail[]) => {
        this.kpiDetails = data;
        this.kpiDetails = this.kpiDetails.filter((v, i) =>
          this.kpiDetails.findIndex(item => item.kpi_name == v.kpi_name) === i);
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });
  }

  public redirect(url: string) {
    if (url === 'print')
      this.printPage();
    else
      this.router.navigate(['/' + url]);
  }

  public printPage() {
    window.print();
  }

  initializeExcelHeaders(): void {
    this.httpService.get('../../../assets/json/excelHeaders.json').subscribe(
      data => {
        this.columnsExcelData = data;
        this.ordersTableExcelHeaderColumns = this.columnsExcelData.ExcelKpiDetails;
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    );
  }

  public exportExcel() {

    this.exportExcelkpiDetails = JSON.parse(JSON.stringify(this.kpiDetails));
    for (let js of this.exportExcelkpiDetails) {
      delete js.id;
      delete js.commPlanId;
      delete js.cdtr_id;
      delete js.comm_plan_id;
      delete js.kpi_id;
      delete js.comm_plan_dtl_id;
      delete js.kpi_type;
      delete js.created_dt;
      delete js.created_by;
      delete js.update_dt;
      delete js.updated_by;
      delete js.effective_date;
    }
    this.dataForExcel = [];
    let reportData = null;
    this.exportExcelkpiDetails.forEach((row: any) => {
      this.dataForExcel.push(Object.values(row))
    })
     reportData = {
      title: 'KPI Details',
      data: this.dataForExcel,
      headers: Object.keys(this.ordersTableExcelHeaderColumns[0])
    }
    this.exportExcelService.exportExcel(reportData);
  }

  initializeColumns(): void {
    this.httpService.get('../../../assets/json/tableColumns.json').subscribe(
      data => {
        this.columnsData = data;
        this.ordersTableColumns = this.columnsData.ViewKpiDetails;
        console.log(this.ordersTableColumns);
        this.buttons = [

          {
            name: 'Back',
            pagenavigation: 'comm-plan'
          },
          {
            name: 'Print',
            pagenavigation: 'print'
          }
        ];
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    );
  }

}
